import Button from '@base/Button/Button';
import H1 from '@base/H1/H1';
import H5 from '@base/H5/H5';
import Image from '@base/Image';
import styled from '@emotion/styled';
import useWindowSize from '@hooks/useWindowSize';
import { mediaQuery, Spacings } from '@styles/index';
import pushRoute from '@utils/pushRoute';

const ResultsAnnounementWrapper = styled.div`
  width: 100vw;
  height: 80vh;
  background: rgba(45, 129, 247, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: -${Spacings.SPACING_10B};
`;

const StyledH1 = styled(H1)`
  width: 480px;
  font-size: ${Spacings.SPACING_10B};
  margin: ${Spacings.SPACING_8B} 0 ${Spacings.SPACING_8B} 0;
  text-align: center;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  width: 252px;
  height: ${Spacings.SPACING_12B};
  margin-top: ${Spacings.SPACING_12B};
  border-radius: ${Spacings.SPACING_2B};
`;

const StyledH5 = styled(H5)`
  margin-left: ${Spacings.SPACING_3B};
`;
const UNSAT_IMAGE_URL =
  'https://static.uacdn.net/web-cms/unsat_school_form.png?q=75&w=640&fm=webp';

const ResultsAnnoucement = () => {
  const { isMobile } = useWindowSize();

  const handleGoToHomepage = () => {
    pushRoute('/', '/');
  };

  return (
    <ResultsAnnounementWrapper>
      <Image
        src={UNSAT_IMAGE_URL}
        width={isMobile ? Spacings.SPACING_38B : Spacings.SPACING_50B}
        height={isMobile ? Spacings.SPACING_14B : Spacings.SPACING_18B}
        alt="illustration"
      />
      <StyledH1>Thank you for showing your interest in UNSAT</StyledH1>
      <ButtonWrapper>
        <Image
          src="unsat-results-icon.svg"
          width={Spacings.SPACING_5B}
          height={Spacings.SPACING_5B}
          alt="illustration"
        />
        <StyledH5>Results will be declared in November</StyledH5>
      </ButtonWrapper>

      <StyledButton
        label="Go to home page"
        onClick={handleGoToHomepage}
        color="black"
      />
    </ResultsAnnounementWrapper>
  );
};

export default ResultsAnnoucement;
